import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Button, TextField, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
const UploadViaUrl = ({ onSubmit }) => {
    const { register, handleSubmit } = useForm();
    const submit = (data) => {
        onSubmit(data.url);
    };
    return (_jsxs(Stack, Object.assign({ spacing: 4 }, { children: [_jsx(Typography, Object.assign({ variant: "h5", fontWeight: "fontWeightSemiBold" }, { children: "Library Link via Upload" })), _jsx("form", Object.assign({ onSubmit: handleSubmit(submit) }, { children: _jsxs(Stack, Object.assign({ direction: "row", spacing: 4 }, { children: [_jsx(TextField, Object.assign({ variant: "outlined", type: "url" }, register('url', { required: true }), { placeholder: "Paste URL", sx: {
                                background: (theme) => theme.palette.background.bg4,
                                width: '260px',
                            } })), _jsx(Button, Object.assign({ variant: "contained", size: "medium", sx: { width: '96px' }, type: "submit" }, { children: "Add" }))] })) }))] })));
};
export default UploadViaUrl;
